import api from "api/api";

const BASE_URL = "accounts/clients/";

export const fetchAllClients = async (sedeParams = {}, sedeHeaders = {}) => {
  try {
    const response = await api.get(BASE_URL, { params: sedeParams, headers: sedeHeaders });
    return response.data;
  } catch (error) {
    console.error('Error al obtener los clientes:', error);
    throw error;
  }
};

export const fetchClientsSimple = async (sedeParams = {}, sedeHeaders = {}) => {
  try {
    const response = await api.get(BASE_URL + 'simple-list/', { params: sedeParams, headers: sedeHeaders });
    return response.data;
  } catch (error) {
    console.error('Error al obtener la lista simple de clientes:', error);
    throw error;
  }
};

export const fetchClientsMinimal = async (sedeParams = {}, sedeHeaders = {}) => {
  try {
    const response = await api.get(BASE_URL + 'minimal-list/', { params: sedeParams, headers: sedeHeaders });
    return response.data;
  } catch (error) {
    console.error('Error al obtener la lista minimal de clientes:', error);
    throw error;
  }
};


export const getClientsCount = async (sedeParams = {}, sedeHeaders = {}) => {
  try {
    const response = await api.get(BASE_URL + 'count/', { params: sedeParams, headers: sedeHeaders });
    return response.data;
  } catch (error) {
    console.error('Error al obtener el conteo de clientes:', error);
    throw error;
  }
};

export const fetchClientById = async (id, sedeParams = {}, sedeHeaders = {}) => {
  try {
    const response = await api.get(BASE_URL + id, { params: sedeParams, headers: sedeHeaders });
    return response.data;
  } catch (error) {
    console.error(`Error al obtener el cliente con ID ${id}:`, error);
    throw error;
  }
};

export const createClient = async (clientData) => {
  try {
    const response = await api.post(BASE_URL, clientData);
    return response.data;
  } catch (error) {
    console.error('Error al crear un cliente:', error);
    throw error;
  }
};

export const updateClient = async (id, clientData) => {
  try {
    const response = await api.patch(`${BASE_URL}${id}/`, clientData);
    return response.data;
  } catch (error) {
    console.error(`Error al actualizar el cliente con ID ${id}:`, error);
    throw error;
  }
};

export const deleteClient = async (id) => {
  try {
    const response = await api.delete(`${BASE_URL}${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error al eliminar el cliente con ID ${id}:`, error);
    throw error;
  }
};

export const importBookingsExcel = async (formData) => {
  try {
    const response = await api.post('studio/bookings/import/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error al importar reservas:", error);
    throw error;
  }
};


export const fetchClientsAtRisk = async (sedeParams = {}, sedeHeaders = {}) => {
  try {
    const response = await api.get('studio/bookings/clientes-en-riesgo/', { params: sedeParams, headers: sedeHeaders });
    return response.data;
  } catch (error) {
    console.error("Error al obtener clientes en riesgo:", error);
    throw error;
  }
};


export const getBookingsByClient = async (clientId, sedeParams = {}, sedeHeaders = {}) => {
  try {
    const response = await api.get(`studio/bookings/by-client/${clientId}/`, { params: sedeParams, headers: sedeHeaders });
    return response.data;
  } catch (error) {
    console.error(`Error al obtener bookings del cliente ${clientId}:`, error);
    throw error;
  }
};

export const getClientDashboard = async (clientId, sedeParams = {}, sedeHeaders = {}) => {
  try {
    const response = await api.get(`${BASE_URL}${clientId}/dashboard/`, { params: sedeParams, headers: sedeHeaders });
    return response.data;
  } catch (error) {
    console.error(`Error al obtener dashboard del cliente ${clientId}:`, error);
    throw error;
  }
};

export const getClientClasesPorMes = async (clientId, year, month, sedeParams = {}, sedeHeaders = {}) => {
  try {
    const response = await api.get(`${BASE_URL}${clientId}/clases-por-mes/`, { 
      params: { year, month, ...sedeParams }, 
      headers: sedeHeaders 
    });
    return response.data;
  } catch (error) {
    console.error(`Error al obtener clases por mes del cliente ${clientId}:`, error);
    throw error;
  }
};

